export enum Permission {
  PartnerPickDevicesManageShoppers = 'manage_shoppers.legacy_permission',
  PartnerBulkDeliveryVehiclesView = 'partner_bulk_delivery_vehicles.view',
  PartnerBulkDeliveryVehiclesModify = 'partner_bulk_delivery_vehicles.modify',
}
